declare global {
  interface Window {
    dataLayer: any[]
  }
}

// Pushes a confirmed lead submission onto the dataLayer.
//
// No tag manager is installed on the site any more, so nothing consumes this
// today — the push is harmless and kept so the event is already in place if a
// container (GTM or another) is added later. It also gives QA a single record
// of every confirmed lead in the console.
//
// `leadId` is used for both `lead_id` and `event_id` so downstream tags
// (e.g. Meta CAPI) can deduplicate the browser and server events.
export function trackFormSubmit({
  formId,
  pageUrl,
  leadId,
}: {
  formId: string
  pageUrl: string
  leadId: string
}) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'form_submission',
    form_id: formId,
    page_path: pageUrl,
    lead_id: leadId,
    event_id: leadId,
  })
}
